import * as React from 'react';
import cn from 'clsx';
import { InlineText1, Radio } from '@cian/ui-kit';
import { UiKitContext } from '@cian/ui-kit/internal/context';
import { IUiKitContext } from '@cian/ui-kit/context/types/IUiKitContext';

import { EObjectType } from '../../../../constants/objectType';

import * as styles from './styles.css';

export interface ICardProps {
  onChange(): void;
  value: EObjectType;
  selectedValue: EObjectType | null;
  name: string;
}

const RADIO_CUSTOM_UI_CONTEXT: IUiKitContext = { deviceType: 'phone', useStaticDeviceType: true };

export const Card: React.FC<ICardProps> = ({ onChange, value, name, selectedValue }) => {
  return (
    <div
      className={cn(styles['card'], {
        [styles['card-flat']]: EObjectType.Flat === value,
        [styles['card-room']]: EObjectType.Room === value,
        [styles['card-land']]: EObjectType.Land === value,
        [styles['card-house']]: EObjectType.House === value,
      })}
      onClick={onChange}
      data-testid="Card"
    >
      <div className={styles['card-top']}>
        <div className={styles['name']}>
          <InlineText1>{name}</InlineText1>
        </div>
        <UiKitContext.Provider value={RADIO_CUSTOM_UI_CONTEXT}>
          <Radio name="ObjectType" value={value} checked={selectedValue === value} />
        </UiKitContext.Provider>
      </div>
    </div>
  );
};

Card.displayName = 'Card';
